var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "h-100 favorites-widget" },
    [
      _c(
        "v-card",
        {
          staticClass: "d-flex flex-column h-100",
          attrs: { elevation: "0", outlined: "", "min-height": "350" },
        },
        [
          _c(
            "v-card-title",
            {
              staticClass:
                "pt-1 pb-0 white--text d-flex align-center justify-space-between",
              class: _vm.$vuetify.theme.dark ? "black" : "primary",
            },
            [
              _c(
                "div",
                { staticClass: "d-flex align-center" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { color: "white", medium: "" },
                    },
                    [_vm._v("star")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "white--text body-font body-1 font-weight-bold text-uppercase",
                    },
                    [_vm._v(_vm._s(_vm.$t("dashboards.myFavorites")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "pl-0 pr-0",
                  attrs: { text: "", small: "", to: `/favorites` },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "white--text text-decoration-underline font-weight-bold",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.seeAll")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "ml-1",
                      attrs: { small: "", color: "white" },
                    },
                    [_vm._v("keyboard_arrow_right")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            {
              staticClass: "d-flex flex-column pb-1 flex-grow-1 pa-0",
              staticStyle: { overflow: "auto" },
            },
            [
              _c(
                "div",
                { staticClass: "grey lighten-4 tabs-subheader-container" },
                [
                  _c(
                    "v-btn-toggle",
                    {
                      staticClass: "tabs-subheader d-flex w-100",
                      staticStyle: { width: "100%" },
                      attrs: { tile: "", group: "", dense: "", mandatory: "" },
                      model: {
                        value: _vm.tabModel,
                        callback: function ($$v) {
                          _vm.tabModel = $$v
                        },
                        expression: "tabModel",
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        { staticClass: "flex-grow-1", attrs: { value: 0 } },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "body-2 font-weight-bold text-uppercase",
                            },
                            [_vm._v(_vm._s(_vm.$t("general.players")))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        { staticClass: "flex-grow-1", attrs: { value: 1 } },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "body-2 font-weight-bold text-uppercase",
                            },
                            [_vm._v(_vm._s(_vm.$t("playerScout.teams")))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        { staticClass: "flex-grow-1", attrs: { value: 2 } },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "body-2 font-weight-bold text-uppercase",
                            },
                            [_vm._v(_vm._s(_vm.$t("app.leagues")))]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "overflow-auto h-100 px-3 pt-2",
                  staticStyle: { background: "transparent" },
                },
                [
                  _vm.tabModel === 0
                    ? _c(
                        "div",
                        { staticClass: "transparent" },
                        [
                          _vm.players && _vm.players.length && !_vm.loading
                            ? _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                _vm._l(_vm.players, function (player, index) {
                                  return _c("PlayerDashboardItem", {
                                    key: index,
                                    attrs: { player: player, embedded: "" },
                                  })
                                }),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          (!_vm.players || !_vm.players.length) && !_vm.loading
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-center align-center flex-column px-3 py-4 mb-7 text-center flex-grow-1",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      style: {
                                        "font-size": _vm.$vuetify.breakpoint
                                          .mdAndUp
                                          ? "80px"
                                          : "60px",
                                      },
                                      attrs: { color: "primary lighten-5" },
                                    },
                                    [_vm._v("star")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "primary--text lighten--text-2 body-1",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "dashboards.placeholderFavorites"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.loading
                            ? _c("v-skeleton-loader", {
                                staticClass: "flex-grow-1",
                                attrs: { type: "list-item@10" },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tabModel === 1
                    ? _c(
                        "div",
                        { staticClass: "transparent" },
                        [
                          _vm.teams && _vm.teams.length && !_vm.loading
                            ? _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                _vm._l(_vm.teams, function (team, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass:
                                        "d-flex justify-space-between align-center py-1",
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "nav-link d-flex align-center",
                                          attrs: { to: "/team/" + team.teamId },
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              height: "22px",
                                              width: "22px",
                                            },
                                            attrs: {
                                              src:
                                                "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                                team.teamId +
                                                ".png",
                                            },
                                            on: {
                                              error: function ($event) {
                                                return _vm.onImageLoadFailure(
                                                  $event,
                                                  "team"
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mx-2 body-1 text-ellipsis",
                                              style: {
                                                "max-width": !_vm.$vuetify
                                                  .breakpoint.xlOnly
                                                  ? "120px"
                                                  : "",
                                              },
                                            },
                                            [_vm._v(_vm._s(team.teamName))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "body-2" }, [
                                        _vm._v(_vm._s(team.leagueName)),
                                      ]),
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          (!_vm.teams || !_vm.teams.length) && !_vm.loading
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-center align-center flex-column px-3 py-4 mb-7 text-center flex-grow-1",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      style: {
                                        "font-size": _vm.$vuetify.breakpoint
                                          .mdAndUp
                                          ? "80px"
                                          : "60px",
                                      },
                                      attrs: { color: "primary lighten-5" },
                                    },
                                    [_vm._v("star")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "primary--text lighten--text-2 body-1",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "dashboards.placeholderTeamFavorites"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.loading
                            ? _c("v-skeleton-loader", {
                                staticClass: "flex-grow-1",
                                attrs: { type: "list-item@10" },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tabModel === 2
                    ? _c(
                        "div",
                        { staticClass: "transparent" },
                        [
                          _vm.leagues && _vm.leagues.length && !_vm.loading
                            ? _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                _vm._l(_vm.leagues, function (league, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass:
                                        "d-flex justify-space-between align-center py-1",
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "nav-link d-flex align-center",
                                          attrs: {
                                            to: "/league/" + league.leagueId,
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              height: "22px",
                                              width: "22px",
                                            },
                                            attrs: {
                                              src:
                                                "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/" +
                                                league.leagueId +
                                                ".png",
                                            },
                                            on: {
                                              error: function ($event) {
                                                return _vm.onImageLoadFailure(
                                                  $event,
                                                  "league"
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mx-2 body-1 text-ellipsis",
                                              style: {
                                                "max-width": !_vm.$vuetify
                                                  .breakpoint.xlOnly
                                                  ? "120px"
                                                  : "",
                                              },
                                            },
                                            [_vm._v(_vm._s(league.leagueName))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "body-2" }, [
                                        _vm._v(_vm._s(league.countryName)),
                                      ]),
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          (!_vm.leagues || !_vm.leagues.length) && !_vm.loading
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-center align-center flex-column px-3 py-4 mb-7 text-center flex-grow-1",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      style: {
                                        "font-size": _vm.$vuetify.breakpoint
                                          .mdAndUp
                                          ? "80px"
                                          : "60px",
                                      },
                                      attrs: { color: "primary lighten-5" },
                                    },
                                    [_vm._v("star")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "primary--text lighten--text-2 body-1",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "dashboards.placeholderLeagueFavorites"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.loading
                            ? _c("v-skeleton-loader", {
                                staticClass: "flex-grow-1",
                                attrs: { type: "list-item@10" },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }